import api from "./api";

const idempotencyKey = () =>
  "purchases-" + Date.now() + "-" + Math.random().toString(16).slice(2);

const withIdempotency = (headers = {}) => ({
  headers: {
    ...headers,
    "Idempotency-Key": idempotencyKey(),
  },
});

export const purchasesService = {
  list(params) {
    return api.get("/purchases", { params });
  },
  create(payload) {
    return api.post("/purchases/create", payload, withIdempotency());
  },
  confirm(id) {
    return api.post(`/purchases/confirm/${id}`, {}, withIdempotency());
  },
  receive(id, actor, items, partialReason) {
    return api.post(`/purchases/receive/${id}`, { actor, items, partialReason }, withIdempotency());
  },
  registerSupplierInvoice(id, payload) {
    return api.post(`/purchases/${id}/supplier-invoice`, payload, withIdempotency());
  },
  paySupplierInvoice(id, payload) {
    return api.post(`/purchases/${id}/pay`, payload, withIdempotency());
  },
  uploadAttachment(id, file) {
    const form = new FormData();
    form.append("attachment", file);
    return api.post(`/purchases/${id}/attachment`, form, withIdempotency({ "Content-Type": "multipart/form-data" }));
  }
};
